/**
 * Created by jonas on 2021-10-22.
 */
import {TrueGritSymbol, TrueGritSymbolStates} from "./TrueGritSymbol";
import {gsap} from "gsap";
import {TrueGritStatics} from "../TrueGritStatics";
import {TrueGrit} from "../TrueGrit";
import {TrueGritSound} from "../sound/TrueGritSound";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {BitmapText} from "pixi.js";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";


export function isTrueGritStackedWildSymbol(value:any):value is TrueGritStackedWildSymbol {
    return value.symbolName === "W2";
}

export class TrueGritStackedWildSymbol extends TrueGritSymbol {
    private totalMultiplier:number = 1;
    private _spriteContainer:PIXI.Container;
    private _fireFlipFlop:boolean = true;
    private _multiplierDisplay:PIXI.Container;
    private _multiTextDynamic:PIXI.BitmapText;
    private _multiTextStatic:PIXI.BitmapText;
    private _multiplierDisplayGlitter:TimelineSprite;
    private _fireContainer:PIXI.Container;
    private isUp:boolean = false;

    constructor() {
        super("W2");
        this._currentStateSprite.position.set(72, 69);
        this._currentStateSprite.anchor.set(0.5, 0.125);
        this._newStateSprite.position.set(72, 69);
        this._newStateSprite.anchor.set(0.5, 0.125);
        this._spriteContainer = new PIXI.Container();
        this._spriteContainer.addChild(this._currentStateSprite, this._newStateSprite);
        this.addChild(this._spriteContainer);

        this._multiplierDisplay = new PIXI.Container();
        this._multiplierDisplay.position.set(55, -120);
        this._multiplierDisplay.alpha = 0;

        this._multiTextStatic = new BitmapText("x", {
            fontName : TrueGritGameAssets.BITMAP_FONT_MULTIPLIER_NUMBERS_ENABLED,
            fontSize : 90,
            tint : 0xffffff
        });
        this._multiTextStatic.anchor = new PIXI.Point(0.5, 0.5);

        this._multiTextDynamic = new BitmapText("1", {
            fontName : TrueGritGameAssets.BITMAP_FONT_MULTIPLIER_NUMBERS_ENABLED,
            fontSize : 110,
            tint : 0xffffff
        });
        this._multiTextDynamic.anchor = new PIXI.Point(0.5, 0.5);

        this._multiplierDisplayGlitter = new TimelineSprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.W2_SPARKS), 30);
        this._multiplierDisplayGlitter.anchor.set(0.5, 0.5);
        this._multiplierDisplayGlitter.hide();

        this._multiplierDisplay.addChild(this._multiplierDisplayGlitter, this._multiTextStatic, this._multiTextDynamic);

        this._fireContainer = new PIXI.Container();
        this.addChild(this._fireContainer, this._multiplierDisplay);
    }

    init(initState:TrueGritSymbolStates):TrueGritSymbol {
        return super.init(initState);
    }

    private playFireAnimation(targetPosition:number):gsap.core.Timeline {
        const sp = new TimelineSprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.W2_FLAME), 30);
        if(this._fireFlipFlop) {
            //Left
            sp.pivot.set(30, 11);
            sp.scale.x = -1;
            sp.position.set(30, targetPosition);
        } else {
            //Right
            sp.pivot.set(30, 11);
            sp.position.set(116, targetPosition);
        }

        const tl = sp.getAnimation();
        tl.add(() => {this._fireContainer.addChild(sp)}, 0);
        tl.add(() => {this._fireContainer.removeChild(sp)});

        this._fireFlipFlop = !this._fireFlipFlop;

        return tl;
    }

    public nudge(steps:{ size:number, multiplier:number }[], isInWin:boolean = true, fastNudge:boolean = false):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const fireTl:gsap.core.Timeline = gsap.timeline();
        const multiplierTl:gsap.core.Timeline = gsap.timeline();
        const initPos = 0;
        let target = 0;


        if (fastNudge){
            const singleStep = {
                size:0,
                multiplier:0
            }
            for (let step of steps){
                singleStep.size += step.size;
                singleStep.multiplier += step.multiplier;
            }

            steps = [singleStep];
        }


        let totalStepSize:number = 0;
        for(let step of steps) {

            //If not first
            if(target != initPos) {
                //wind up
                tl.add(gsap.to(this._spriteContainer.position, {duration : 0.3, y : target + 10}));
            }

            //Calculate next target
            totalStepSize += step.size;
            target = initPos - (totalStepSize * TrueGritStatics.symbolHeight);

            //release
            if (isInWin){
                tl.add(()=>{TrueGrit.soundPlayer.playSound(TrueGritSound.X_NUDGE_SOUNDS.next())});
            } else {
                tl.add(()=>{TrueGrit.soundPlayer.playSound(TrueGritSound.X_NUDGE_NO_WIN)});
            }
            tl.add(this.setState(TrueGritSymbolStates.SPIN, "_spin", 0.02));
            tl.add(gsap.to(this._spriteContainer.position, {
                duration : 0.1,
                y : target,
                ease : "none"
            }), "<");
            tl.add(this.setState(TrueGritSymbolStates.NORMAL, "", 0.02), ">-0.02");
            fireTl.add(this.playFireAnimation(target), tl.duration());

            multiplierTl.add(this.updateMultiplier(this.totalMultiplier + step.multiplier), tl.duration());

            tl.add(TrueGrit.allReelsView.getLandingShake(true, this.reelId, true));
        }

        multiplierTl.add(this.getMultiplierTextGlitter(), "<");

        tl.add(multiplierTl, 0);
        tl.add(fireTl, 0);
        tl.add(() => {this.isUp = true});

        return tl;
    }

    //public fastNudge(multiplier:number)

    public shrink():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        if(!this.isUp) {
            return tl;
        }
        const fastSpin  = TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false);

        const target:number = 0;

        tl.add(this.setState(TrueGritSymbolStates.SPIN, "_spin", 0.04));
        tl.add(gsap.to(this._spriteContainer.position, {
            duration : 0.2,
            y : target,
            ease : "power2.in"
        }), "<");
        tl.add(this.setState(TrueGritSymbolStates.NORMAL, "", 0.02), ">-0.02");

        tl.add(gsap.to(this._multiplierDisplay, {duration : 0.2, pixi : {scale : 0.5, y : 110}, ease : "power2.in"}), 0)

        tl.add(() => {TrueGrit.soundPlayer.playSound(TrueGritSound.X_NUDGE_RESET)});

        const multiplierAlphaDuration = fastSpin ? 0.01 :  0.2;

        tl.add([
            TrueGrit.allReelsView.getLandingShake(false, this.reelId),
            gsap.to(this._multiplierDisplay, {duration : multiplierAlphaDuration, alpha : 0})
        ]);

        if (!fastSpin){
            tl.add(()=>{}, "+=0.2");
        }

        return tl;
    }

    private updateMultiplier(multiplier:number):gsap.core.Timeline {
        this.totalMultiplier = multiplier;
        const tl:gsap.core.Timeline = gsap.timeline();

        // #326
        let toScale: number;
        if (multiplier < 10) {
            toScale = 1.5;
        } else if (multiplier < 20) {
            toScale = 0.9;
        } else if (multiplier < 100) {
            toScale = 0.8;
        } else {
            toScale = 0.7;
        }
        tl.add(gsap.to(this._multiTextDynamic, {duration : 0.05, pixi : {scale : 0}}));
        tl.add(() => {
            if(multiplier < 10) {
                toScale = 1.75;
                this._multiTextStatic.position.set(-28, 0);
                this._multiTextDynamic.position.set(20, 0);
            } else {
                this._multiTextStatic.position.set(-27, 0);
                this._multiTextDynamic.position.set(22, 0);
            }
            this._multiTextStatic.scale.set(toScale);
            this._multiTextDynamic.text = `${multiplier}`
        });
        tl.add(gsap.to(this._multiTextDynamic, {duration : 0.3, pixi : {scale : toScale}, ease : "elastic.out(0.8,0.3)"}));

        tl.add(gsap.to(this._multiplierDisplay, {
            duration : 0.1,
            pixi : {scale : 1, y : -120, alpha : 1},
            ease : "power2.in"
        }), 0)

        //Todo - add multiplier animation. Either in the symbol it self or in another view.

        return tl;
    }

    private getMultiplierTextGlitter():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(this._multiplierDisplayGlitter.getAnimationAutoShowHide(true, true));
        return tl;
    }
}